import {ActionCreatorDefinition, createAction} from "redux-ts";
import {Bank, BankAccount, CreditCardState, PaymentMethodAmount} from "core/redux/deposit/DepositReduxState";
import {PaymentMethod} from "enum/PaymentMethod";
import {CreditCardType} from "enum/CreditCardType";
import {Currency} from "platform/enum/Currency";

export const SetPaymentMethodType: string = "SetPaymentMethod";
export const SetDepositMinAmountType: string = "SetDepositMinAmount";
export const SetPredefinedAmountsType: string = "SetPredefinedAmounts";
export const SetCreditCardProviderType: string = "SetCreditCardProvider";
export const SetCreditCardType: string = "SetCreditCard";
export const SetCreditCardValidType: string = "SetCreditCardValid";
export const SelectDepositBankType: string = "SelectDepositBank";
export const SelectDepositBankAccountType: string = "SelectDepositBankAccount";
export const DoSubmitDepositCCType: string = "DoSubmitDepositCC";
export const SetWireTransferCurrencyType: string = "SetWireTransferCurrency";
export const SetPaymentMethodAmountType: string = "SetPaymentMethodAmount";

export interface SetPaymentMethodPayload {

    paymentMethod: PaymentMethod;
}

export interface SetDepositMinAmountPayload {

    amount: number;
}

export interface SetPredefinedAmountsPayload {

    amounts: number[];
}

export interface SetCreditCardProviderPayload {

    creditCardType: CreditCardType;
    maxCardLength: number;
}

export interface SetCreditCardValidPayload {

    valid: boolean;
}

export interface SetCreditCardPayload {

    creditCard: CreditCardState;
}

export interface SelectDepositBankPayload {

    bank: Bank;
}

export interface SelectDepositBankAccountPayload {

    bankAccount: BankAccount;
}

export interface DoSubmitDepositCCPayload {

    values: CreditCardState;
}

export interface SetWireTransferCurrencyPayload {

    wireTransferCurrency: Currency;
}

export interface SetPaymentMethodAmountPayload {

    paymentMethodAmount: PaymentMethodAmount;
}

export const SetPaymentMethod: ActionCreatorDefinition<SetPaymentMethodPayload, any> = createAction<SetPaymentMethodPayload>(SetPaymentMethodType);
export const SetDepositMinAmount: ActionCreatorDefinition<SetDepositMinAmountPayload, any> = createAction<SetDepositMinAmountPayload>(SetDepositMinAmountType);
export const SetPredefinedAmounts: ActionCreatorDefinition<SetPredefinedAmountsPayload, any> = createAction<SetPredefinedAmountsPayload>(SetPredefinedAmountsType);
export const SetCreditCardProvider: ActionCreatorDefinition<SetCreditCardProviderPayload, any> = createAction<SetCreditCardProviderPayload>(SetCreditCardProviderType);
export const SetCreditCard: ActionCreatorDefinition<SetCreditCardPayload, any> = createAction<SetCreditCardPayload>(SetCreditCardType);
export const SetCreditCardValid: ActionCreatorDefinition<SetCreditCardValidPayload, any> = createAction<SetCreditCardValidPayload>(SetCreditCardValidType);
export const SelectDepositBank: ActionCreatorDefinition<SelectDepositBankPayload, any> = createAction<SelectDepositBankPayload>(SelectDepositBankType);
export const SelectDepositBankAccount: ActionCreatorDefinition<SelectDepositBankAccountPayload, any> = createAction<SelectDepositBankAccountPayload>(SelectDepositBankAccountType);
export const DoSubmitDepositCC: ActionCreatorDefinition<DoSubmitDepositCCPayload, any> = createAction<DoSubmitDepositCCPayload>(DoSubmitDepositCCType);
export const SetWireTransferCurrency: ActionCreatorDefinition<SetWireTransferCurrencyPayload, any> = createAction<SetWireTransferCurrencyPayload>(SetWireTransferCurrencyType);
export const SetPaymentMethodAmount: ActionCreatorDefinition<SetPaymentMethodAmountPayload, any> = createAction<SetPaymentMethodAmountPayload>(SetPaymentMethodAmountType);
